<template>
	<div class="fondoModal">
		<div>
			<div>
				<div class="card text-left">
					<div class="card-header bg-info">
						Editor de locutores
						<button type="button" class="close" aria-label="Close" @click="cerrar">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>

					<div class="card-body">
						<div class="row">
							<div class="col text-center">
								<img :src="avatarData" style="width:80px;height:80px;" class="rounded-circle" />
								<br>
								<button class="btn btn-sm btn-info mt-1" @click="setAvatar = true">Cambiar</button>
							</div>
							<div class="col">
								<div class="form-group">
									<label for="">Nombre</label>
									<input type="text" class="form-control form-control-sm" placeholder="Nombre" v-model="locutor.nombre">
								</div>

								<div class="form-group">
									<label for="">Apellidos</label>
									<input type="text" class="form-control form-control-sm" placeholder="Apellidos" v-model="locutor.apellidos">
								</div>
							</div>
							<div class="col">
								<div class="form-group">
									<label for="">Estilos</label>
									<input type="text" class="form-control form-control-sm" placeholder="Escribe un estilo y pulsa intro" @keypress.enter="setEstilo($event)">
								</div>
								<div class="badge badge-info p-1 m-1" style="cursor:pointer;" v-for="estilo in locutor.estilos" :key="estilo" @click="quitaEstilo(estilo)">{{estilo}}</div>
							</div>
							<div class="col">
								<div class="form-group">
									<label for="">Sexo</label>
									<br>
									<button class="btn btn-sm" :class="(locutor.sexo === 'hombre') ? 'btn-primary' : 'btn-default'" @click="setSexo('hombre')">
										Hombre
									</button>
									<button class="btn btn-sm" :class="(locutor.sexo === 'mujer') ? 'btn-primary' : 'btn-default'" @click="setSexo('mujer')">
										Mujer
									</button>
								</div>
								<div class="form-group">
									<label for="">Estado</label>
									<br>
									<button class="btn btn-sm" :class="(locutor.activo === true) ? 'btn-primary' : 'btn-default'" @click="locutor.activo = true">
										Activo
									</button>
									<button class="btn btn-sm" :class="(locutor.activo === false) ? 'btn-primary' : 'btn-default'" @click="locutor.activo = false">
										Inactivo
									</button>
								</div>
							</div>
						</div>
					</div>
					<div class="card-body bg-light">
						<div class="row">
							<div class="col">
								<div class="form-group">
									<label for="">Procedencia</label>
									<select name="" class="form-control form-control-sm" @change="setProcedencia($event)" v-model="locutor.procedencia_ID">
										<option :value="null">Selecciona procedencia</option>
										<option :value="p.ID_procedencia" v-for="p in listadoProcedencias" :key="p.ID_procedencia">{{p.nombre}}</option>
										<option :value="'nuevo'">Crear nueva</option>
									</select>
								</div>
								<div class="form-group" v-if="nuevaProcedencia">
									<label for="">Nueva procedencia</label>
									<div class="input-group input-group-sm">
										<input type="text" class="form-control form-control-sm" v-model="nuevaProcedenciaValue">
										<div class="input-group-btn">
											<button class="btn btn-sm btn-primary" @click="guardaProcedencia()">Crear</button>
										</div>
									</div>
								</div>
							</div>
							<div class="col">
								<div class="form-group">
									<label for="">E-mail</label>
									<input type="text" class="form-control form-control-sm" placeholder="locutor@empresa.com" v-model="locutor.email">
								</div>
							</div>
							<div class="col">
								<div class="form-group">
									<label for="">Teléfono</label>
									<input type="text" class="form-control form-control-sm" placeholder="6XX XXX XXX" v-model="locutor.telefono">
								</div>
							</div>
						</div>
					</div>
					<div class="card-footer">
						<button class="btn btn-sm btn-primary" @click="guardar()">
							Guardar
						</button>
					</div>
				</div>

				<set-avatar v-if="setAvatar" @cerrar="setAvatar = false" @img="setNuevoAvatar($event)"></set-avatar>
			</div>
		</div>
	</div>
</template>


<script>

import SetAvatar from '../cropper/crop-image'
import API from '../../services/api'

export default {
	name: 'editor-locutor',
	props: ['locutor'],
	components: {
		'set-avatar': SetAvatar
	},

	data: function () {
		return {
			setAvatar: false,
			listadoProcedencias: [],
			avatar: null,
			nuevoAvatar: false,
			nuevaProcedencia: false,
			nuevaProcedenciaValue: ''
		}
	},

	created () {
		API.getProcedencias()
			.then(res => {
				this.listadoProcedencias = res.data.procedencias
			})
			.catch(e => {
				this.$store.commit('alertas/nueva', {
					titulo: 'Error',
					mensaje: e.response.data.error
				})
			})
	},

	computed: {
		avatarData () {
			if (this.nuevoAvatar) {
				return this.avatar
			} else {
				return this.locutor.avatar
			}
		}
	},

	methods: {

		setNuevoAvatar (e) {
			this.avatar = e
			this.nuevoAvatar = true
		},

		setSexo (sexo) {
			this.locutor.sexo = sexo

			if (this.locutor.avatar.match(/\.svg$/)) {
				this.locutor.avatar = (sexo === 'hombre') ? '/media/static/hombre.svg' : '/media/static/mujer.svg'
			}
		},

		setEstilo (ev) {
			this.locutor.estilos.push(ev.target.value.toLowerCase())
			ev.target.value = ''
		},

		quitaEstilo (estilo) {
			this.locutor.estilos.splice(this.locutor.estilos.indexOf(estilo), 1)
		},

		setProcedencia (e) {
			if (e.target.value === 'nuevo') {
				this.nuevaProcedencia = true
			} else {
				this.locutor.procedencia_ID = e.target.value
			}
		},

		guardaProcedencia () {
			API.setProcedencia({nombre: this.nuevaProcedenciaValue})
				.then(res => {
					this.listadoProcedencias.push(res.data.procedencia)
					this.locutor.procedencia = res.data.procedencia.ID_procedencia

					this.nuevaProcedenciaValue = ''
					this.nuevaProcedencia = false
				})
				.catch(e => {
					this.$store.commit('alertas/nueva', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},

		guardar () {
			const form = new FormData()
			form.append('locutor', JSON.stringify(this.locutor))

			if (this.nuevoAvatar) {
				form.append('avatar', this.avatar)
			}

			API.setLocutor(form)
				.then(res => {
					this.$store.commit('alertas/alert', {
						titulo: 'Cambios guardados',
						mensaje: 'Se han guardado los cambios correctamente'
					})
				})
				.catch(e => {
					this.$store.commit('alertas/nueva', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},

		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/produccion/vue/components/produccion/editor-locutor.vue